import React, {Component} from 'react';
import * as messageConstants from '../../../shared/messages';
import './RedirectUri.scss';

class RedirectUri extends Component {

    handleUpdateEvent = (evt) => {
        this.props.handleUpdateWsFedRedirectUri(evt.target.value);
    }
    handleOpenHelpDocPage = () => {
        //todo change help url
        this.props.handleOpenHelpDocPage("#Topics/OneSign/SSO/SAML_.htm");
    }

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="pt-31">
                <p className="sba-subtitle">
                    {messageConstants.WS_FED_URI_TITLE}
                </p>
                &nbsp;
                <div className="add-edit-subtitle">
                    {messageConstants.WS_FED_URI_SUBTITLE}
                </div>
                <input className="redirect-uri-input form-control attributes-input"
                       type='text'
                       name="redirectUri"
                       value={this.props.redirectUri}
                       placeholder={messageConstants.WS_FED_URI_PLACEHOLDER}
                       onChange={this.handleUpdateEvent}/>
            </div>
        );
    }
}

export default RedirectUri;



// WEBPACK FOOTER //
// ./src/components/WsFederationApp/RedirectUri/RedirectUri.js